import {getService, getServiceAuthorized, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from "../configs/api"
import { axiosPrivate } from '../configs/api';
const RegistrationService = {};

// const loginPort = 9003;

RegistrationService.getLanguages = () => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/languages`,
);

RegistrationService.getOrganizations = () => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/organizations`,
);

RegistrationService.getHierarchies = (selectedOrg=2) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/hierarchies/${selectedOrg}`,
);

RegistrationService.getOfficerforInfluencer = (branchId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/branch/TSOs/${branchId}`,
);

RegistrationService.getBranchesforInfluencer = (city_id, state_id) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/branches/${city_id}/${state_id}`,
);
RegistrationService.getBranch = (countryId, cityId, stateId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/branches/${countryId}/${cityId}/${stateId}`,
)
RegistrationService.register = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/registrationProfileNode/temporaryRegister`,
  payload
);

RegistrationService.registrationTemporaryAndBasic = payload =>
AxiosRequest.post(
    `/${route.registration}/api/v3/registrationsNode/all/registrationsWithEkyc`,
    payload,
  );
  RegistrationService.enrollByTseDealer = (payload, hierDesc) =>
  AxiosRequest.post(
    hierDesc === 'Dealer'
    ? `/${route.registration}/api/v4/registrationProfileNode/contractor/registration/dealerekyc/or/tseekyc`
    : `/${route.registration}/api/v3/registrationProfileNode/contractor/registration/dealerekyc/or/tseekyc`,
    payload,
    // `/${route.registration}/api/v3/registrationProfileNode/contractor/registration/dealer/or/tse`,
    // payload,
  );
RegistrationService.forgotPassword = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/registrationProfileNode/change/password/by/otp`,
  payload
);

RegistrationService.sendOTPSignup = payload =>
AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/send/mobile/otp`,
    payload,
  );

RegistrationService.basicProfile = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/profileNode/basic/profile`,
  payload,  
);

RegistrationService.login = (payload) => AxiosRequest.post(
  `/${route.auth}/api/v2/authNode/login`,
  payload
);

RegistrationService.verifyPhone = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/registrationProfileNode/verify/contact/number/by/otp`,
  payload
);

RegistrationService.completeProfile = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/loginAuthNode/basic/profile`,
  payload
);

RegistrationService.allCities = (countryId, stateId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/cities/${countryId}/${stateId}`
);

RegistrationService.allStates = (countryId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/states/${countryId}`
);

RegistrationService.allCountries = () => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/countries`
);

RegistrationService.allDistricts = (countryId, stateId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/districts/${countryId}/${stateId}?`,
  // { Authorization: `Bearer ${token}` },
);
RegistrationService.talukasByDistrict = (districtId, token) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/talukas/${districtId}?`,
  token
)
RegistrationService.getMappingOfficersForDealers = (contactId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/TSOs/${contactId}`,
);
// RegistrationService.getDealersOrTse = (officerId, districtId, talukId, brandId, token) => getServiceAuthorized(
//   `/${route.registration}/api/v1/masterAuthNode/find/TSE/or/dealer/${officerId}/${brandId}?taluka_id=${talukId}&district_id=${districtId}`,
//  token
// );
RegistrationService.getDealersOrTse = (officerId, districtId,talukId,brandId,payload, token) =>
  AxiosRequest.post(
    `/${route.registration}/api/v1/masterAuthNode/find/TSE/or/dealer/${officerId}/${brandId}?taluka_id=${talukId}&district_id=${districtId}`,
    payload,
    token,
  );
  
RegistrationService.getMappingOfficersForInfluencers = (branchId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/branch/TSOs/${branchId}`,
);

RegistrationService.getDealersForTSO = (contactId) => AxiosRequest.get(
  `/${route.registration}/api/v1/masterAuthNode/all/dealers/${contactId}`,
);
RegistrationService.updateAdditionalDetails = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/profileNode/additional/profile`,
  payload,
);
RegistrationService.updateKYCDetails = (formData) => AxiosRequest.postForm(
  `/${route.registration}/api/v3/registrationProfileNode/upload/KYC`,
  formData
);

RegistrationService.getBasicProfileInfo = () => AxiosRequest.get(
  `/${route.registration}/api/v1/profileNode/basic/profile/fetch?`,
);

RegistrationService.getProductNames = (selectedBrandId, token) => AxiosRequest.get(
  `/${route.pointAccrual}/api/v2/salesNode/sale/get/cement/products/${selectedBrandId}?`,
  { Authorization: `Bearer ${token}` },
)

RegistrationService.salesGetAllDealers = () => AxiosRequest.get(
  `/${route.pointAccrual}/api/v2/salesNode/sale/get/all/dealersPurchaseRegistration?`
  );

  RegistrationService.salesGetAllSearchedDealer = (payload) => AxiosRequest.post(
    `/${route.pointAccrual}/api/v2/salesNode/sale/get/all/dealersSearch?`,
    payload,
  );

RegistrationService.submitPurchaseRegistration = (payload) => AxiosRequest.post(
  `/${route.pointAccrual}/api/v4/salesNode/purchase/register`,
  payload
)

RegistrationService.listOfUnapprovedUsers = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/registrationProfileNode/get/all/unapproved/users`,
  payload,
)

RegistrationService.userApprovalByTSO = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v3/registrationProfileNode/user/approval/byTSO`,
  payload  
)

RegistrationService.listOfTSOs = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/registrationProfileNode/list/of/tso/by/branch`,
  payload,
)

RegistrationService.assignTsoToUser = (payload, token) => AxiosRequest.post(
  `/${route.registration}/api/v1/registrationProfileNode/assign/tso`,
  payload,
  token,
)

RegistrationService.getInfluencers = (personaId) => AxiosRequest.get(
  `/${route.pointAccrual}/api/v1/salesNode/sale/get/all/contractors/${personaId}?`
)

RegistrationService.dealerPurchaseRegistration = (payload) => AxiosRequest.post(
  `/${route.pointAccrual}/api/v4/salesNode/dealer/purchase/register`,
  payload
)
RegistrationService.kycType = () => AxiosRequest.get(
  `/${route.registration}/api/v1/masterNode/all/KYC/types`,
)

// RegistrationService.salesGetAllDealers = (hierId, token) => getServiceAuthorized(
//   `/${route.registration}/api/v1/salesNode/sale/get/all/dealers/${hierId}`,
//   token
// )
// RegistrationService.getProductNames = (selectedBrandId, token) => getServiceAuthorized(
//   `/${route.registration}/api/v1/salesNode/sale/get/cement/products/${selectedBrandId}`,
//   token
// )
RegistrationService.getUnApprovedUsers = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v3/registrationProfileNode/get/all/unapproved/usersUsingTaluka`,
  payload,
)
RegistrationService.sendOtp = (payload) => AxiosRequest.post(
  `/${route.auth}/api/v1/authNode/sendOtp`,
  payload
);
RegistrationService.validateOtp = (payload) => AxiosRequest.post(
  `/${route.auth}/api/v1/authNode/validOtp`,
  payload
);
RegistrationService.forgotPasswordSet = payload =>
AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/change/password/by/otp`,
    payload,
  );

  // In case of basic registration get the list of state district and taluka as per TSE
  RegistrationService.getStateDistrictTaluka = () => AxiosRequest.get(
    `/${route.registration}/api/v1/masterNode/all/state/city/dis/List`,
  )

  RegistrationService.changeBrand = payload =>
  AxiosRequest.post(`/${route.auth}/api/v2/authNode/changebrand`, payload);

  RegistrationService.addressOtp = (payload) =>
  AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/address/otp`,
    payload,
  );

  RegistrationService.approveDocumentTSE = (payload) =>
  AxiosRequest.post(
    `/${route.registration}/api/v3/registrationProfileNode/approvedDocument`,
    payload
  );

  RegistrationService.myContractorsTSE = (
    conName,
    conMob,
    dealer,
    offset,
    token
  ) =>
  AxiosRequest.get(
      // `/${route.registration}/api/v3/registrationProfileNode/get/users/tse?limit=10&offset=${offset}&contractor_name=${conName}&contractor_mobile=${conMob}&dealer_id=${dealer}`
      `/${route.registration}/api/v3/registrationProfileNode/get/users/tsebytalukas?limit=10&offset=${offset}&contractor_name=${conName}&contractor_mobile=${conMob}&dealer_id=${dealer}`,
      token,
    );

    RegistrationService.myDealersTSE = (tseId) =>
  AxiosRequest.get(
    `/${route.registration}/api/v2/masterAuthNode/find/AllDealerRetailerArs/${tseId}?`
  );

  RegistrationService.getMyContractorsTSEDetails = (conId) =>
  AxiosRequest.get(
    `/${route.registration}/api/v3/registrationProfileNode/get/users/tse/details/${conId}?`
  );

  RegistrationService.deleteProfile = () =>
    AxiosRequest.post(
      `/${route.registration}/api/v1/profileNode/delete/my/account`,
    );

  RegistrationService.brandEnrollment = (payload) =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/registrationsNode/applyForBrand`,
      payload,
    );

  // RegistrationService.getMobileDetails = (payload) => 
  //   AxiosRequest.post(
  //     `/${route.registration}/api/v3/registrationsNode/checkUserByBrand`,
  //     payload,
  //   )

  RegistrationService.enrollMultibrandByTseDealer = (payload) =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/registrationProfileNode/contractor/brandRegistration/dealer/or/tse`,
      // `/${route.registration}/api/v3/registrationProfileNode/contractor/registration/dealerekyc/or/tseekyc`,
      payload,
    )

  RegistrationService.myAllContractorsTSE = () =>
    AxiosRequest.get(
      `/${route.registration}/api/v3/registrationProfileNode/get/users/tse/bytalukas?limit=100000`,
    )

 
  RegistrationService.contentSpotUnauthorised = (query) => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/oauth-contentspots/${query}?`,
  )

  RegistrationService.getLocationData = () =>
    AxiosRequest.get(
      `/${route.registration}/api/v3/masterNode/all/state/city/dis/List?`,
    );

  RegistrationService.fetchKYCInfo = (formData) =>
    AxiosRequest.postForm(
      // `/${route.registration}/api/v3/registrationProfileNode/fetch/kyc/info`,
      `/${route.registration}/api/v3/registrationProfileNode/upload/registrationuploadAndVerifyEKYC`,
      formData
    );

  RegistrationService.uploadProfileImageNode = (formData) =>
    AxiosRequest.postForm(
      `/${route.registration}/api/v3/registrationProfileNode/upload/profileImageUpload`,
      formData
    );

  RegistrationService.selfieList = (search) =>
    AxiosRequest.get(
      `/${route.pointAccrual}/api/v1/salesNode/get/selfie/All/Info/Data?brand_id=&mobile=&dealer_id=&from_date=&is_verified=${search.status}&to_date=&name_contractor=&search=${search.nameOrNumber}`,
    );

  RegistrationService.adaniPassport = () =>
    AxiosRequest.get(
      `/${route.registration}/api/v1/profileNode/passport/fetch?`,
    );

    RegistrationService.getAlliedProductNames = () =>
      AxiosRequest.get(
        `/${route.pointAccrual}/api/v1/alliedProductNode/sale/get/allied/products?`
      );

    RegistrationService.salesGetAllAlliedDealers = (payload) =>
      AxiosRequest.post(
        `/${route.pointAccrual}/api/v1/alliedProductNode/sale/get/allied/dealers?`,
        payload
      );

    RegistrationService.submitAlliedPurchaseRegistration = (payload) =>
      AxiosRequest.post(
        `/${route.pointAccrual}/api/v1/alliedProductNode/purchase/register?`,
        payload
      );

    RegistrationService.logout = (payload) =>
      AxiosRequest.post(`/${route.auth}/api/v1/authNode/logout`, {});

export default RegistrationService;
